import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onBulkStatusChange, onBulkEmail, onBulkExport, onClearSelection }) => {
  const statusOptions = [
    { value: 'screening', label: 'Move to Screening' },
    { value: 'shortlisted', label: 'Shortlist' },
    { value: 'interview_scheduled', label: 'Schedule Interview' },
    { value: 'rejected', label: 'Reject' }
  ];

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-card border border-border rounded-lg shadow-modal p-4 min-w-[320px] max-w-2xl">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full">
            <span className="text-sm font-semibold text-primary">{selectedCount}</span>
          </div>
          <span className="text-sm font-medium text-foreground">
            {selectedCount} candidate{selectedCount > 1 ? 's' : ''} selected
          </span>
        </div>

        <button
          onClick={onClearSelection}
          className="p-1 hover:bg-muted rounded transition-smooth"
        >
          <Icon name="X" size={20} className="text-muted-foreground" />
        </button>
      </div>

      <div className="flex flex-wrap items-center gap-2 mt-4">
        <Select
          placeholder="Change Status"
          options={statusOptions}
          value=""
          onChange={onBulkStatusChange}
          className="flex-1 min-w-[180px]"
        />

        <Button
          variant="outline"
          size="sm"
          iconName="Mail"
          iconPosition="left"
          onClick={onBulkEmail}
        >
          Send Email
        </Button>

        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          iconPosition="left"
          onClick={onBulkExport}
        >
          Export
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsBar;